import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  NativeSelect,
  TableSortLabel,
  TextField,
  Typography,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { blue } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Axios from "axios";
import { EncryptStorage } from "encrypt-storage";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ClientWiseSpinner from "../../../../_metronic/layout/components/customize/ClientWiseSpinner";
import FileUpload from "../Components/FileUpload";
import { PlaidLinkComponent } from "../PlaidLinkComponent";
import CreateBankAccount from "./BankAccountsModal/Create";
import DeleteBankAccount from "./BankAccountsModal/Delete";
import EditBankAccount from "./BankAccountsModal/Edit";
import ShowNoteComponent from "./ShowNoteComponent";
// import { BankAccountContext } from "../../../../hooks/ContextStore";
import ClientWiseAlert from "../../../../_metronic/layout/components/customize/Alert";
import Loading from "../../../pages/Loading";
import { debounce } from "lodash";
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import Position from "../../../modules/CustomizeComponent/PositionIcon";
import TextInputField from "../../../../_metronic/layout/components/InputFields";
import GreenCheckBadge from "../Components/Badge";

async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function BankAccountRow(props) {
  const { row, setBanks, client_case_id } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();
  const mobile = window.matchMedia("(max-width: 768px)");
  const [isMobile, setIsMobile] = useState(mobile.matches);

  useEffect(() => {
    const windowHandler = () => {
      setIsMobile(mobile.matches);
      if (!isMobile) {
        setOpen(false);
      }
    };

    mobile.addEventListener("change", windowHandler);
    return () => {
      mobile.removeEventListener("change", windowHandler);
    };
  }, []);

  const handleChange = debounce(async (property, value) => {
    try {
      if (value && value._isAMomentObject) {
        debugger
        const date_dt = new Date(value);
        const new_date = new Date(
          date_dt.getFullYear(),
          date_dt.getMonth(),
          date_dt.getDate(),
          10,
          56,
          0
        );
        row[property] = new_date;
      } else {
        row[property] = value;
      }

      const propertiesToDelete = [ 
        "institutional_id",
        "plaid_account_id",
        "net_value",
        "division_net_value",
        "asset_value",
        "debt",
        "isPlaid",
        "to_spouse", 
      ];
      
      propertiesToDelete.forEach(prop => delete row[prop]);
      
      const response = await Axios.put(
        `api/estate/bank/account/${row.id}`,
        row
      );

      if (response && response.status === 200) {
        setBanks(response.data.data);
      }
    } catch (err) {
      console.error("Error updating property:", err);
    }
  }, 500);

  const positions = [
    "Husband",
    "Wife",
    "Joint",
    "Client",
    "Spouse",
    "Third Party",
    "Other"
  ]; 
  
  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: blue }} />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" className="font-weight-normal">
            {`${row.institution_name ?? ''} ${row.type?.charAt(0).toUpperCase() + row.type?.slice(1)} ${row.account_number} ` } <Position position ={row.position}/>
          </TableCell>
          <TableCell align="left" className="font-weight-normal">
            {row.balance ? `$${row.balance} as of (${moment(row.balance_date).format("L")})` : "0"}
          </TableCell>
          {/* {!isMobile ? <TableCell align="left" className="font-weight-normal">${row.other_liens}</TableCell> : null } */}
          <TableCell align="left" className="font-weight-normal">
            {row.client_sp ? `$${row.client_sp}` : "0"}
          </TableCell>
          <TableCell align="left" className="font-weight-normal">
            {row.spouse_sp ? `$${row.spouse_sp}` : "0"}
          </TableCell>
          <TableCell align="left" className="font-weight-normal">
            {row.net_value ? `$${row.net_value}` : "0"}
          </TableCell>
        <TableCell align="left"> 
          <ShowNoteComponent row={row} api='api/estate/bank/account' />
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DeleteBankAccount
              row={row}
              setBanks={setBanks}
              client_case_id={client_case_id}
            />
          </div>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <FileUpload
              row={row}
              client_case_id={client_case_id}
              source={"bank-account"}
            />
          </div>
           <GreenCheckBadge show={row.client_sp > 0 || row.spouse_sp > 0}/>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div className="shadow mb-3">
                <List>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Bank :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField
                        defaultValue={row.institution_name}
                        onChange={(e) => handleChange('institution_name', e.target.value)}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Account # :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                     <TextInputField
                        defaultValue={row.account_number}
                        onChange={(e) => handleChange('account_number', e.target.value)}
                      /> 
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Account Type:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                      <NativeSelect
                          className={`form-control form-control-solid h-auto mt-2 border-1 m-1 p-1 px-3`}
                          inputProps={{
                            name: 'type',
                          }}
                        //  defaultValue={formik.values.type}
                          onChange={(e) => handleChange('type', e.target.value)} 
                          defaultValue={row.type}
                        >
                        <option value="savings">savings</option>
                        <option value="checking"  >checking</option>
                        <option value="money market">money market</option>
                        <option value="certificate of deposit">certificate of deposit</option>
                        </NativeSelect>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name(s) on Account :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >  
                     <TextInputField
                        defaultValue={row.account_name}
                        onChange={(e) => handleChange('account_name', e.target.value)}
                      /> 
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Balance :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal  d-flex align-center  border-0 m-0 p-0"> 
                      <div>
                         <TextInputField                 
                          defaultValue={row.balance}
                          onChange={(e) => handleChange('balance', e.target.value)}
                        />
                      </div>
                      <div className="pt-3 px-5">
                        <Typography variant="p">as of</Typography> 
                      </div>
                      <div>
                        <MuiPickersUtilsProvider utils={MomentUtils}> 
                          <KeyboardDateTimePicker
                            disableToolbar
                            variant="inline"
                            format="MM/DD/yyyy"  
                            className="m-0"
                            id="date-picker-inline"
                            onChange={(balance_date) => handleChange('balance_date', balance_date)}
                            value={new Date(row.balance_date)} 
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Client SP:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField
                        defaultValue={row.client_sp}
                        onChange={(e) => handleChange('client_sp', e.target.value)}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Spouse SP :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField
                        defaultValue={row.spouse_sp}
                        onChange={(e) => handleChange('spouse_sp', e.target.value)}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Net Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      <TextInputField defaultValue={row.net_value} disabled={true} />
                    </ListItemSecondaryAction>
                  </ListItem> 
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name/Control of:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                      <NativeSelect
                          className={`form-control form-control-solid h-auto mt-2 border-1 m-1 p-1 px-3`}
                          inputProps={{
                            name: 'positions',
                          }}
                        //  defaultValue={formik.values.type}
                          onChange={(e) => handleChange('position', e.target.value)} 
                          defaultValue={row.positions}
                        >
                        {
                          positions.map((position, index) => {
                            return (
                              <option key={index} value={position}>{position}</option>
                            )
                          })
                        } 
                        </NativeSelect>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                </List>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function BankAccount(props) {
  const { handleOpen } = props;
  const encryptStorage = new EncryptStorage("secret-key");
  const decypt_data = encryptStorage.getItem("case_details");
  const client_case_id = decypt_data ? decypt_data.case.id : null;
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [order, setOrder]                 = useState('desc');
  const [orderBy, setOrderBy]             = useState('id');
  const [errMessage, setErrMessage] = useState('');
      const visuallyHidden = {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    }; 
  const fetch_bank_accounts = () => {
    setOpen(true);
    Axios.get("api/estate/bank/" + client_case_id)
      .then((res) => {
        let banks = res.data.data;
        banks.sort((a, b) =>
          a.institution_name > b.institution_name ? 1 : -1
        );
        setBanks(banks);
        setOpen(false);
      })
      .catch((err) => {
        console.log("error", err);
        setOpen(false);
      });
  };
  const openAlert = ()=> {
    setShowAlert(true);

}

  const closeAlert = ()=> {
    setShowAlert(false); 
  }
  
  const handleAutoUpdatePlaid = async () => {
    setLoading(true);
    
    //Filter bank accounts to plaid accounts only.
    const plaid_accounts = banks.filter((bank) => bank.isPlaid);
    
    //return the function if no plaid accounts connected.
    if(!plaid_accounts.length) {
      setLoading(false);
      setErrMessage('Bank is not found');
      openAlert();
      return;
    }
    
    //get plaid connected accounts institutions.
    const plaid_institutions = await Axios.get(`api/estate/bank/account/institutions/${client_case_id}`)
      .then(res => {return res.data})
      .catch((e)=> { 
        setLoading(false);
      });
    
    //check for balances for plaid accounts.
    const updated_accounts = await Promise.all(plaid_accounts.map(async (account) => {
      const institution_lookup = plaid_institutions.find((institution) => institution.institunional_id === account.institutional_id);
      const institution_access_token = institution_lookup?.access_token;
      
      if(!institution_access_token) return ;
      
      //fetch balance for account.
      const updated_balance = await Axios.post(process.env.REACT_APP_NODE_URL + "/balance", {access_token: institution_access_token, options:{account_ids: [account.plaid_account_id]}})
          .then(res => {
            return res.data.accounts[0].balances.available
          })
          .catch((e)=>{ 
            setLoading(false);
          });
      return {
        id: account.id,
        account_name: account.account_name,
        type: account.type,
        balance: updated_balance,
        account_number: account.account_number,
        institution_name: account.institution_name,
        notes: account.notes,
        client_case_id: client_case_id,
        balance_date: new Date().toLocaleDateString('en-CA'),
        isPlaid: true,
        institutional_id: account.institutional_id
      }
    })); 
    var insert = await Axios.put(
      "api/estate/bank/account/insert/update",
      updated_accounts
    ).catch((e)=>{  
      setLoading(false);
    });
    
    if (insert) {
      setBanks(insert.data.data);
    }
    
    setLoading(false);
    
  };

  useEffect(() => {
    fetch_bank_accounts();
  }, []);

  

    const headCells = [
      {
        id: 'type',
        numeric: false,
        disablePadding: true,
        label: 'Description',
      },
      {
        id: 'balance',
        numeric: true,
        disablePadding: true,
        label: 'Value',
      }, 
      {
        id: 'client_sp',
        numeric: true,
        disablePadding: false,
        label: 'Client SP',
      },
      {
        id: 'spouse_sp',
        numeric: true,
        disablePadding: false,
        label: 'Spouse SP',
      },
      {
        id: 'net_value',
        numeric: true,
        disablePadding: false,
        label: 'Net Value',
      },
      {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
      },
    ];

    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc'; 
      var newValue = sortByProperty(banks, property, isAsc ? 'desc' : 'asc');

      setBanks(newValue);
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };

    function sortByProperty(arr, prop, order = "asc") {
      return [...arr].sort((a, b) => {
        let valA = a[prop];
        let valB = b[prop];

        // Handle dates
        if (Date.parse(valA) && Date.parse(valB)) {
          valA = new Date(valA);
          valB = new Date(valB);
        }

        if (valA < valB) return order === "asc" ? -1 : 1;
        if (valA > valB) return order === "asc" ? 1 : -1;
        return 0;
      });
    }
 function EnhancedTableHead(props) {
      const { order, orderBy, onRequestSort } =
        props;
      const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
      };

      return (
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox"> 
            </TableCell>
            {headCells.map((headCell) => (
              <TableCell
                className="font-weight-bold text-uppercase text-muted fs-1"
                key={headCell.id}
                align={'left'}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
              >
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      );
    }
  return (
    <>
      <ClientWiseSpinner show={loading} />
      <ClientWiseAlert showAlert={showAlert} closeAlert={closeAlert} message={errMessage} status={'danger'}/>
      <div id="real-property" className={`card h-100 card-custom `}> 
        <hr />
        <div className="card-title mb-0">
          <div className="d-flex px-9 align-items-center">
            
            <div className="ml-auto">
              <CreateBankAccount
                handleOpen={handleOpen}
                client_case_id={client_case_id}
                setBanks={setBanks}
              />
            </div> 
            <div className="ml-6">
              <button
                className="btn btn-primary"
                onClick={handleAutoUpdatePlaid}
              >
                Update Linked Accounts
              </button>
            </div>
          </div>
        </div>
        <div className="pb-10 pl-10 pr-10 pt-0">
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <EnhancedTableHead  
                  order={order}
                  orderBy={orderBy} 
                  onRequestSort={handleRequestSort}
                  rowCount={banks.length}
                /> 
              <TableBody>
                {banks.map((row) => (
                  <BankAccountRow
                    key={row.id}
                    row={row}
                    setBanks={setBanks}
                    client_case_id={client_case_id}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      {open && <Loading />}
    </>
  );
}
export default BankAccount;
